import { State, Action } from 'src/types'
import {
  SET_SELECTED_PARTS,
  SET_ALL_LEATHER_COLOR,
  SET_BASE_MODEL,
  SET_DOMINANT_ARM,
  SET_SIZE,
  SET_BACK_LACE,
  SET_MOUTON_COLOR,
  SET_MATERIAL_PACK,
  SET_WEB_PARTS,
  SET_ATOMS_LABEL,
  SET_LEATHER_COLOR,
  SET_EDGE_COLOR,
  SET_LININGS,
  SET_HAMIDASHI,
  SET_FINGER_GUARD_TYPE,
  SET_LACE_COLOR,
  SET_STITCH_COLOR,
  SET_EMBROIDERIES,
  ADD_EMBROIDERY,
  REMOVE_EMBROIDERY,
  SET_WEB_COLOR,
  SET_THUMB_HOOK,
  SET_LITTLE_HOOK,
  SET_INDEX_COVER_COLOR,
  SET_PERSONAL,
  SET_THUMB_OUT_COLOR,
  SET_THUMB_WEB_COLOR,
  SET_INDEX_WEB_COLOR,
  SET_INDEX_MIDDLE_COLOR,
  SET_MIDDLE_INDEX_COLOR,
  SET_MIDDLE_RING_COLOR,
  SET_RING_MIDDLE_COLOR,
  SET_RING_LITTLE_COLOR,
  SET_LITTLE_RING_COLOR,
  SET_LITTLE_OUT_COLOR,
  SET_LIST_BELT_COLOR,
  SET_THUMB_WEB_AND_INDEX_WEB,
  SET_TANNER,
  SET_THUMB_ROOT_COLOR,
  SET_WEB_COLOR_2,
  SET_MOLDING_ORDER,
  SET_FIGURE_PANEL_NUMBER
} from 'src/features/atoms/glove/us/constants/actionType'
import { liningColorEnObjs } from 'src/features/atoms/glove/us/constants/colors'
import {
  colorInitialState,
  gloveColorInitialState,
  gloveColorInitialStateEn,
  gloveColorInitialStateKo,
  initialEmbroideryState
} from 'src/features/atoms/glove/us/reducer'
import {
  baseInitialState,
  baseInitialStateEn,
  baseInitialStateKo,
  colorInitialStateEn,
  colorInitialStateKo,
  initialPersonalState,
  unselectedState,
  unselectedStateEn,
  unselectedStateKo,
  initialGloveImagesState
} from 'src/constants'

export const initialInfielderState: State = {
  ...baseInitialState,
  kinds: unselectedState,
  tanner: unselectedState,
  backLace: unselectedState,
  webParts: unselectedState,
  ...colorInitialState,
  ...gloveColorInitialState,
  mouton: unselectedState,
  atomsLabel: unselectedState,
  loopOfRingFinger: unselectedState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}
export const initialInfielderStateEn: State = {
  ...baseInitialStateEn,
  tanner: unselectedStateEn,
  backLace: unselectedStateEn,
  moldingOrder: unselectedStateEn,
  webParts: unselectedStateEn,
  ...colorInitialStateEn,
  ...gloveColorInitialStateEn,
  mouton: unselectedStateEn,
  atomsLabel: unselectedStateEn,
  loopOfRingFinger: unselectedState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialOutfielderStateEn: State = {
  ...baseInitialStateEn,
  tanner: unselectedStateEn,
  backLace: unselectedStateEn,
  webParts: unselectedStateEn,
  moldingOrder: unselectedStateEn,
  ...colorInitialStateEn,
  ...gloveColorInitialStateEn,
  mouton: unselectedStateEn,
  atomsLabel: unselectedStateEn,
  loopOfRingFinger: unselectedState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialPitcherStateEn: State = {
  ...baseInitialStateEn,
  tanner: unselectedStateEn,
  backLace: unselectedStateEn,
  backStyle: unselectedStateEn,
  materialPack: unselectedStateEn,
  webParts: unselectedStateEn,
  moldingOrder: unselectedStateEn,
  ...colorInitialStateEn,
  ...gloveColorInitialStateEn,
  mouton: unselectedStateEn,
  atomsLabel: unselectedStateEn,
  loopOfRingFinger: unselectedState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialUsGloveStateEn: State = {
  ...baseInitialStateEn,
  tanner: unselectedStateEn,
  backLace: unselectedStateEn,
  backStyle: unselectedStateEn,
  materialPack: unselectedStateEn,
  webParts: unselectedStateEn,
  moldingOrder: unselectedStateEn,
  ...colorInitialStateEn,
  ...gloveColorInitialStateEn,
  mouton: unselectedStateEn,
  atomsLabel: unselectedStateEn,
  loopOfRingFinger: unselectedState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

// 韓国人が、USモデルをオーダーする際の初期値
export const initialUsGloveStateKo: State = {
  ...baseInitialStateKo,
  tanner: unselectedStateKo,
  backLace: unselectedStateKo,
  backStyle: unselectedStateKo,
  materialPack: unselectedStateKo,
  webParts: unselectedStateKo,
  moldingOrder: unselectedStateKo,
  loopOfRingFinger: unselectedState,
  ...colorInitialStateKo,
  ...gloveColorInitialStateKo,
  mouton: unselectedStateKo,
  atomsLabel: unselectedStateKo,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

// 日本語用 / i18nを満たすためだけに定義。実際には使用しない
export const initialUsGloveState: State = {
  ...baseInitialState,
  kinds: unselectedState,
  tanner: unselectedState,
  backLace: unselectedState,
  webParts: unselectedState,
  loopOfRingFinger: unselectedState,
  ...colorInitialState,
  ...gloveColorInitialState,
  mouton: unselectedState,
  atomsLabel: unselectedState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const gloveReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case SET_TANNER:
      return { ...state, tanner: action.tanner }
    case SET_SELECTED_PARTS:
      return { ...state, parts: action.parts }
    case SET_ALL_LEATHER_COLOR:
      return {
        ...state,
        all: action.all,
        catchFace: action.all,
        web: action.all,
        web2: action.all,
        thumbHook: action.all,
        littleHook: action.all,
        edge: action.all,
        indexCover: action.all,
        listBelt: action.all,
        // 裏革にはない色が「全体」として指定されたら、裏革のみ既存stateを維持させる
        // 裏革にもある色が「全体」として指定されたらもちろん反映を許可
        linings: liningColorEnObjs.some((x) => x.color === action.all.color) ? action.all : state.linings, // 裏革
        // 内野手用グラブ
        thumbOut: action.all,
        thumbWeb: action.all,
        thumbRoot: action.all,
        thumbWebAndIndexWeb: action.all,
        indexWeb: action.all,
        indexMiddle: action.all,
        middleIndex: action.all,
        middleRing: action.all,
        ringMiddle: action.all,
        ringLittle: action.all,
        littleRing: action.all,
        littleOut: action.all
      }
    case SET_BASE_MODEL:
      const isSequentialRollGlove = ['AKG-6', 'AGL-603', 'APL-UR026+', 'AKG-GT07'].includes(action?.baseModel?.productNumber) // eslint-disable-line
      return {
        ...state,
        baseModel: action.baseModel,
        kinds: action.kinds,
        bankLaceDirection: isSequentialRollGlove ? { label: 'レギュラー巻き', value: 'sequentialRoll' } : { label: '逆巻き', value: 'reverseRoll' }
      }
    case SET_DOMINANT_ARM:
      return { ...state, dominantArm: action.dominantArm }
    case SET_SIZE:
      return { ...state, size: action.size }
    case SET_BACK_LACE:
      return { ...state, backLace: action.backLace, figurePanelNum: 1 }
    case SET_WEB_PARTS:
      return { ...state, webParts: action.webParts }
    case SET_MATERIAL_PACK:
      return { ...state, materialPack: action.materialPack }
    case SET_ATOMS_LABEL:
      return { ...state, atomsLabel: action.atomsLabel, figurePanelNum: 1 }
    case SET_MOLDING_ORDER:
      return { ...state, moldingOrder: action.moldingOrder }
    case SET_LEATHER_COLOR:
      return { ...state, catchFace: action.catchFace }
    case SET_EDGE_COLOR:
      return { ...state, edge: action.edge }
    case SET_WEB_COLOR: {
      const isNeverSetWeb2 = state?.web2?.value === 'unselected'
      return isNeverSetWeb2 ? { ...state, web: action.web, web2: action.web } : { ...state, web: action.web }
    }
    case SET_WEB_COLOR_2:
      return { ...state, web2: action.web2 }
    // 内野手用グラブ
    case SET_THUMB_OUT_COLOR:
      return { ...state, thumbOut: action.thumbOut }
    case SET_THUMB_WEB_COLOR:
      return { ...state, thumbWeb: action.thumbWeb }
    case SET_THUMB_ROOT_COLOR:
      return { ...state, thumbRoot: action.thumbRoot }
    case SET_THUMB_WEB_AND_INDEX_WEB:
      return { ...state, thumbWebAndIndexWeb: action.thumbWebAndIndexWeb }
    case SET_INDEX_WEB_COLOR:
      return { ...state, indexWeb: action.indexWeb }
    case SET_INDEX_MIDDLE_COLOR:
      return { ...state, indexMiddle: action.indexMiddle }
    case SET_MIDDLE_INDEX_COLOR:
      return { ...state, middleIndex: action.middleIndex }
    case SET_MIDDLE_RING_COLOR:
      return { ...state, middleRing: action.middleRing }
    case SET_RING_MIDDLE_COLOR:
      return { ...state, ringMiddle: action.ringMiddle }
    case SET_RING_LITTLE_COLOR:
      return { ...state, ringLittle: action.ringLittle }
    case SET_LITTLE_RING_COLOR:
      return { ...state, littleRing: action.littleRing }
    case SET_LITTLE_OUT_COLOR:
      return { ...state, littleOut: action.littleOut }
    case SET_LIST_BELT_COLOR:
      return { ...state, listBelt: action.listBelt }
    case SET_LININGS:
      return { ...state, linings: action.linings, figurePanelNum: 1 }
    case SET_HAMIDASHI:
      return { ...state, hamidashi: action.hamidashi }
    case SET_FINGER_GUARD_TYPE:
      return { ...state, fingerGuardType: action.fingerGuardType, figurePanelNum: 1 }
    case SET_LACE_COLOR:
      return { ...state, lace: action.lace }
    case SET_STITCH_COLOR:
      return { ...state, stitch: action.stitch }
    case SET_MOUTON_COLOR:
      return { ...state, mouton: action.mouton }
    case SET_EMBROIDERIES:
      return { ...state, embroideries: action.embroideries, figurePanelNum: 1 }
    case ADD_EMBROIDERY: // incrementの方が合っている気がする
      return { ...state, embroideries: action.embroideries }
    case REMOVE_EMBROIDERY: // decrementの方が合っている気がする
      return { ...state, embroideries: action.embroideries }
    case SET_THUMB_HOOK:
      return { ...state, thumbHook: action.thumbHook }
    case SET_LITTLE_HOOK:
      return { ...state, littleHook: action.littleHook }
    case SET_INDEX_COVER_COLOR:
      return { ...state, indexCover: action.indexCover }
    case SET_PERSONAL:
      return { ...state, personal: action.personal }
    case SET_FIGURE_PANEL_NUMBER:
      return { ...state, figurePanelNum: action.figurePanelNum }

    default:
      return state
  }
}
